import {
  ActionSetting,
  ActionType,
  AvailSubActionType,
} from '#/components/ui/messages/model';
import { Select } from '@mantine/core';
import { ComponentProps, ReactNode } from 'react';

export const makeKFunc = (keyPrefix: string | undefined) => {
  function k(strings: TemplateStringsArray, ...values: Array<string | number>) {
    let key = keyPrefix ? `${keyPrefix}.` : '';

    const strs = [...strings];
    const vs = [...values];

    while (strs.length > 0 || vs.length > 0) {
      const s = strs.shift();
      if (s) {
        key += s;
      }
      const v = vs.shift();
      if (v) {
        key += v;
      }
    }
    return key;
  }

  return k;
};

export const AVAIL_SUB_ACTION_SETTING_OPTIONS: Array<{
  label: string;
  value: AvailSubActionType;
}> = [
  { value: 'open_link', label: 'open link' },
  { value: 'message_box', label: 'message box' },
];

export const SelectSubAction = (props: ComponentProps<typeof Select>) => {
  return <Select data={AVAIL_SUB_ACTION_SETTING_OPTIONS} {...props} />;
};

export type ActionEditorConfig<Key extends ActionType, Props extends ActionSetting> = {
  key: Key;
  Fields: (props: { keyPrefix?: string }) => ReactNode;
  Preview: (props: { value: Props }) => ReactNode;
  Actions: () => ReactNode;
  name: string;
};
